import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const GroupCard = ({ group }) => {
  const { t, currentLanguage } = useLanguage();

  const statusConfig = {
    active: {
      label: { fr: 'Actif', ar: 'نشط' },
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    pending: {
      label: { fr: 'En attente', ar: 'قيد الانتظار' },
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    completed: {
      label: { fr: 'Terminé', ar: 'مكتمل' },
      color: 'text-muted-foreground',
      bgColor: 'bg-muted'
    }
  };

  const config = statusConfig?.[group?.status] || statusConfig?.pending;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Always use en-US locale for universal date format (Western numerals)
    return date?.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const progressPercentage = (group?.currentPilgrims / group?.totalCapacity) * 100;

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm hover:shadow-warm-md transition-smooth overflow-hidden">
      <div className="relative h-32 md:h-40 overflow-hidden">
        <Image 
          src={group?.image}
          alt={group?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3">
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${config?.bgColor} ${config?.color}`}>
            {config?.label?.[currentLanguage]}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h4 className="text-base md:text-lg font-semibold text-foreground mb-2 line-clamp-1">
          {group?.name}
        </h4>
        
        <div className="space-y-2 mb-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} />
            <span>{formatDate(group?.departureDate)}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={16} />
            <span>{group?.destination}</span>
          </div>
        </div>

        <div className="mb-3">
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-muted-foreground">
              {t('dashboard.pilgrims')}
            </span>
            <span className="font-medium text-foreground data-text">
              {group?.currentPilgrims}/{group?.totalCapacity}
            </span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div 
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-border">
          <div className="flex items-center gap-2">
            <Icon name="User" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{group?.supervisor}</span>
          </div>
          <button className="text-sm text-primary hover:text-primary/80 font-medium transition-smooth">
            {t('dashboard.viewDetails')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupCard;